export const formatDollar = (value) => {
  const dollarUSLocale = Intl.NumberFormat('en-US')
  return dollarUSLocale.format(Math.round(value))
}

export const pickMiddleOffer = (offers = []) => {
  if (!(offers.length > 1)) return offers
  const sorted = [...offers].sort((a, b) => a.terms - b.terms)
  return [sorted[Math.floor(sorted.length / 2)]]
}

export const formatTitleForMobile = (title) => {
  if (!title) return ''
  const words = title.split(' ')
  if (words.length <= 1) return title
  const midpoint = Math.ceil(words.length / 2)
  return words.slice(0, midpoint).join(' ') + '\n' + words.slice(midpoint).join(' ')
}
